export default __webpack_public_path__ + "static/media/2384.4054bb69.png";